import { Link, Outlet, createRootRoute } from "@tanstack/react-router";
import { RouteError } from "../components/route-error";

export const Route = createRootRoute({
  component: Root,
  // Replaces the whole page, so it is the skip link's target itself.
  notFoundComponent: () => (
    <main id="main" className="page">
      <h1>Page not found</h1>
      <Link to="/">Return home</Link>
    </main>
  ),
  errorComponent: ({ reset }) => <RouteError onRetry={reset} />,
});

/**
 * Deliberately bare. The signed-in shell belongs to `_authenticated/_workspace`, which renders
 * only once the session and onboarding are settled; drawn here, it would appear around a page
 * the visitor is about to be sent away from.
 */
function Root() {
  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <Outlet />
    </>
  );
}
